import { render, staticRenderFns } from "./AddCommentPage.vue?vue&type=template&id=0c5c7af1&scoped=true&"
import script from "./AddCommentPage.vue?vue&type=script&lang=js&"
export * from "./AddCommentPage.vue?vue&type=script&lang=js&"
import style0 from "./AddCommentPage.vue?vue&type=style&index=0&id=0c5c7af1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c7af1",
  null
  
)

export default component.exports